import { render, staticRenderFns } from "./amsPort.vue?vue&type=template&id=6e97144a&"
import script from "./amsPort.vue?vue&type=script&lang=js&"
export * from "./amsPort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e97144a')) {
      api.createRecord('6e97144a', component.options)
    } else {
      api.reload('6e97144a', component.options)
    }
    module.hot.accept("./amsPort.vue?vue&type=template&id=6e97144a&", function () {
      api.rerender('6e97144a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/amsPort.vue"
export default component.exports